import React from 'react';
import translationsHe from '../../translations/translationsHe';
import translationsEn from '../../translations/translationsEn';
import translationsRu from '../../translations/translationsRu';
import translationsAr from '../../translations/translationsAr';
import translationsFr from '../../translations/translationsFr';
import translationsUk from '../../translations/translationsUk';
import { BlockedSiteInfo } from '../../hooks/useAppConfig';
import './siteNotAvailable.less';

/** the site's translations never load for a blocked site (they come with its config) - the browser language picks */
const TRANSLATIONS: Record<string, any> = {
  he: translationsHe,
  en: translationsEn,
  ru: translationsRu,
  ar: translationsAr,
  fr: translationsFr,
  uk: translationsUk,
};

/**
 * What a visitor sees on the website of an agency that is not active / not paying (AGENCY_SITE_NOT_ACTIVE):
 * the agency's logo and name, and that the site is not available right now. Nothing else of the site loads.
 */
const SiteNotAvailable: React.FC<{ info: BlockedSiteInfo }> = ({ info }) => {
  const lang = (navigator.language || 'he').slice(0, 2).toLowerCase();
  const t = (TRANSLATIONS[lang] ?? translationsHe).siteNotAvailable ?? translationsHe.siteNotAvailable;
  const rtl = lang === 'he' || lang === 'ar' || !TRANSLATIONS[lang];

  return (
    <div className="site-not-available" dir={rtl ? 'rtl' : 'ltr'}>
      <div className="site-not-available-card">
        {info.logo ? <img className="site-not-available-logo" src={info.logo} alt={info.name} /> : null}
        {info.name ? <h2>{info.name}</h2> : null}
        <h1>{t.title}</h1>
        <p>{t.text}</p>
      </div>
    </div>
  );
};

export default SiteNotAvailable;
